import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {PaginationComponent} from "@components/pagination/pagination.component";
import {SearchPanelComponent} from "@components/search-panel/search-panel.component";
import {ClickedItem} from '../../app.component';
import {SearchConfig} from '@components/my-requests/my-requests.component';
import {OdooService} from '@services/odoo.service';
import {ApiService, ResponsePost, Response} from '@services/api.service';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {HttpClientModule} from '@angular/common/http';

@Component({
  selector: 'app-ims',
  imports: [CommonModule, HttpClientModule, PaginationComponent, SearchPanelComponent],
  templateUrl: './ims.component.html',
  styleUrl: './ims.component.css'
})
export class ImsComponent implements OnInit {

  @Output() rowClicked = new EventEmitter<ClickedItem>();
  @Output() navigate = new EventEmitter<string>();

  @ViewChild('iframe') private iframeElement!: ElementRef<HTMLIFrameElement>;

  documents: any[] = []
  pagedData: any[] = []
  itemsPerPage: number = 10;
  currentPage: number = 1;
  totalPages: number = 0;

  documentTypes: [] = [];

  searchPanelConfig: SearchConfig[] = [
    {key: 'name', label: 'Nome', type: 'text'},
    {key: 'type', label: 'Tipo', type: 'select'},
    {key: 'date_from', label: 'Dal', type: 'date'},
    {key: 'date_to', label: 'Al', type: 'date'},
  ]

  currentSort: {
    field: string; direction: 'asc' | 'desc'
  } = {
    field: 'id',
    direction: 'desc',
  }

  currentFilters: any = {}

  constructor(
    private odooService: OdooService,
    private apiService: ApiService
  ) {
  }

  ngOnInit(): void {
    this.fetchDocuments({})
    this.fetchDocumentsTypes()
  }

  fetchDocumentsTypes(): void {

    const typeConfig = this.searchPanelConfig.find(config => config.key === 'type')

    if (typeConfig) {
      this.apiService.getImsDocumentTypes().pipe(
        map(response => response.data.sort((a: any, b: any) => a.label.localeCompare(b.label))),
        catchError(error => {
          console.error("Errore nel recupero dei types", error);
          return of([])
        })
      ).subscribe({
        next: (types: any) => {
          typeConfig.options = types.map((item: any) => {
            return {
              label: item.label,
              value: item.id
            };
          });
        },
        error: error => {
          console.error("Errore nel recupero dei types", error);
        }
      })
    }
  }

  fetchDocuments(params: any) {

    params = {
      ...params,
      direction: this.currentSort.direction,
      order: this.currentSort.field
    }

    this.apiService.getImsDocuments(params).pipe(
      map((response: ResponsePost) => {
        if (response.result.status != 'error') {
          return response.result.data
        } else {
          return []
        }
      }),
      catchError(error => {
        console.error("Errore nel recupero dei documenti ims", error);
        return of([])
      })
    ).subscribe(
      procedures => {
        this.documents = procedures;
        this.totalPages = Math.ceil(this.documents.length / this.itemsPerPage);
        this.paginateData();
      }
    )
  }

  paginateData() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    ;
    const endIndex = startIndex + this.itemsPerPage;
    this.pagedData = this.documents.slice(startIndex, endIndex);
  }

  setOrder(field: string) {
    if (this.currentSort.field === field) {
      this.currentSort.direction = this.currentSort.direction === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSort.field = field;
      this.currentSort.direction = 'asc'
    }
    this.fetchDocuments(this.currentFilters)
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.paginateData()
    }
  }

  onSearchParamChange(params: any): void {
    this.currentFilters = params
    this.fetchDocuments(params);
  }

  downloadDocument(id: number, type: string) {
    this.apiService.getDocument(id).subscribe((response: any) => {
      const fileBase64 = response.content;
      const fileName = response.fileName;
      const mimeType = type.toLowerCase() || "application/octet-stream";

      const byteCharacters = atob(fileBase64);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: mimeType});

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);

    });
  }

  previewDocument(id: number, type: string) {
    this.apiService.getDocument(id).subscribe((response: any) => {
      this.iframeElement.nativeElement.setAttribute('src', `data:${type};base64,${response.content}`);
    });
  }

  closePreview() {
    this.iframeElement.nativeElement.removeAttribute('src');
  }


}
